exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-summary .summary{min-height:inherit}.custom-badge{font-size:15px;font-weight:700}.card.card-dashboard .table td,.card.card-dashboard .table th{font-size:.9rem;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d4d54bde","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/Dashboard/Resources/assets/js/views/index.vue
// module id = sQU2
// module chunks = 0